import i18next from 'i18next'
import React from 'react'
import { SharingLayout } from '../cms/header/pageHeader/sharing.layout'
import { TextBlockLayout } from '../cms/modernBlocks/blocks/textBlock/textBlock.layout'
import { ReadSpeaker } from '../readspeaker/readspeaker.widget'

export const RootLayout = {
  Error: (p: { kind: 'notFound' | 'connectionError' | 'unauthorized', showReadspeaker: boolean }) => {
    return (
      <main id="a11y-main" className='main main--error'>
        <article className='page page--error'>
          <div className='page__content'>
            <header className='pageheader ph--text'>
              <div className='ph__inner ls-container--l'>
                <div className='ph__content'>
                  <div className='ph__content-inner'>
                    <h1 className='ph__title title--l' dangerouslySetInnerHTML={{ __html: i18next.t('Error:404.Title') }} />
                  </div>
                </div>

                <div className="ph__visual ls-inner-container--m">
                  <div className='ph__visual-inner fit-picture'>
                    <svg className="ph__mask" height="241" viewBox="0 0 47 241" width="47" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path clipRule="evenodd" d="m0 0v241l46.8611-241z" fillRule="evenodd"/></svg>
                  </div>
                </div>
              </div>
            </header>

            <SharingLayout.Wrap>
              {p.showReadspeaker == true && <ReadSpeaker keyId="a1" encodedUrl={encodeURI(window.location.href)} readElementId={'a11y-main'} />}
            </SharingLayout.Wrap>

            {p.kind == 'notFound' ? (
              <>
                <section id="block-error-0" className="block block--text">
                  <TextBlockLayout.Inner amountNested={0}>
                    <TextBlockLayout.Content
                      text={i18next.t('Error:404.Intro')}
                      showPrimary={true}
                      primaryAction={{
                        kind: 'link',
                        isLinkExternal: false,
                        target: '_self',
                        title: i18next.t('Error:404.Button'),
                        url: '/',
                      }}
                      showSecondary={false}
                      showActionAsLink={false}
                    />
                  </TextBlockLayout.Inner>
                </section>
              </>
            ) : (
              <>
                <section id="block-error-0" className="block block--text">
                  <TextBlockLayout.Inner amountNested={0}>
                    <TextBlockLayout.Content
                      text={i18next.t('Error:404.Intro')}
                      showPrimary={false}
                      showSecondary={false}
                      showActionAsLink={false}
                    />
                  </TextBlockLayout.Inner>
                </section>
              </>
            )}
          </div>
        </article>
      </main>
    )
  }
}
